import initializeEntity from 'web-app/react/entities/factory/initialize';
import {type Entity} from 'web-app/react/entities/factory';
import {reducersObj, type RootState} from 'web-app/react/redux/main-reducer';
import store from 'web-app/react/redux/store';

import PlansEntity from './entities/plans/index';
import ParentalPermissionsEntity from './entities/parental-permissions/index';
import SessionVersionsEntity from './entities/session-versions/index';
import ProductVersionsEntity from './entities/product-versions/index';
import ChildPlanBehaviorsEntity from './entities/plans/child-plans-behaviors-entity';
import ChildrenEntity from './entities/children/index';
import EmployeesEntity from './entities/employees/index';
import GoHomeWithChildrenEntity from './entities/go-home-with-children/index';

export const entities: Array<Entity<RootState, any>> = [
    PlansEntity as MadeAnyDuringTs45Update,
    SessionVersionsEntity as MadeAnyDuringTs45Update,
    ProductVersionsEntity as MadeAnyDuringTs45Update,
    ChildPlanBehaviorsEntity as MadeAnyDuringTs45Update,
    ChildrenEntity as MadeAnyDuringTs45Update,
    EmployeesEntity as MadeAnyDuringTs45Update,
    ParentalPermissionsEntity as MadeAnyDuringTs45Update,
    GoHomeWithChildrenEntity as MadeAnyDuringTs45Update,
];

const initializeEntities = () => {
    entities.forEach(entity => {
        initializeEntity<RootState>(store, reducersObj, entity);
    });
};

export default initializeEntities;
